/**
 * @desc override to ui-select to change selection focus on hover
 * @example <ui-select ui-select-hover></ui-select>
 */
;(function () {
  angular.module('contrast.ui-select').directive('uiSelectHover', uiSelectHover)

  function uiSelectHover($) {
    'ngInject'

    return {
      require: 'uiSelect',
      link: link
    }

    function link(scope, element, attrs, $select) {
      $(element).on('mouseover', '.ui-select-choices-row', function () {
        var elem = this,
          id = elem.getAttribute('id'),
          index = id ? parseInt(id.slice(id.lastIndexOf('-') + 1)) : -1

        if (index >= 0) {
          if ($select.groups) {
            $select.activeIndex = getItemIndex(elem, index, $select.groups)
          } else {
            $select.activeIndex = index
          }
          scope.$apply()
        }
      })
    }

    function getItemIndex(elem, index, groups) {
      var groupIndex = getGroupIndex(elem.parentElement),
        itemIndex = 0

      for (var i = 0; i <= groupIndex; i++) {
        if (i == groupIndex) {
          itemIndex += index
        } else {
          if (groups[i]) {
            itemIndex += groups[i].items.length
          }
        }
      }

      return itemIndex
    }

    function getGroupIndex(elem) {
      var i = 0

      while ((elem = elem.previousElementSibling) != null) {
        i++
      }

      return i
    }
  }
})()
